import { collection, deleteDoc, doc, onSnapshot, query, setDoc, where } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export interface Block {
  blockerUid: string;
  blockedUid: string;
  createdAt: string;
}

function blockDocId(blockerUid: string, blockedUid: string) {
  return `block_${blockerUid}_to_${blockedUid}`;
}

export const blockService = {
  subscribeToBlockedUsers(blockerUid: string, callback: (blockedUids: string[]) => void) {
    const blockerQuery = query(collection(db, 'blocks'), where('blockerUid', '==', blockerUid));
    return onSnapshot(blockerQuery, snap => {
      const blockedUids: string[] = [];
      snap.forEach(d => blockedUids.push(d.data().blockedUid));
      callback(blockedUids);
    });
  },

  subscribeToBlockedByUsers(blockedUid: string, callback: (blockedByUids: string[]) => void) {
    const blockedQuery = query(collection(db, 'blocks'), where('blockedUid', '==', blockedUid));
    return onSnapshot(blockedQuery, snap => {
      const blockedByUids: string[] = [];
      snap.forEach(d => blockedByUids.push(d.data().blockerUid));
      callback(blockedByUids);
    });
  },

  async blockUser(blockerUid: string, blockedUid: string): Promise<void> {
    await setDoc(doc(db, 'blocks', blockDocId(blockerUid, blockedUid)), {
      blockerUid,
      blockedUid,
      createdAt: new Date().toISOString(),
    });
  },

  async unblockUser(blockerUid: string, blockedUid: string): Promise<void> {
    await deleteDoc(doc(db, 'blocks', blockDocId(blockerUid, blockedUid)));
  },
};
